module.exports = __webpack_public_path__ + "static/absa-logo-red-231e08659c0f006615b83916a630d35f.png";